import styled from "styled-components";

export const StyledThreadScreen = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  padding: 100px 30px 10px 30px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: 10% 30% 5% 30%;
  }
  .messages-display {
    flex-grow: 1;
    overflow-y: auto;
    padding-bottom: 80px;
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
`;

export const InputWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  padding-bottom: 20px;
  left: 20px;
  right: 20px;
  min-height: 60px;
  max-height: 222px;
  background-color: ${({ theme }) => theme.colors.background};
`;
export const Header = styled.div`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.background};
  text-align: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0px;
  font-size: 16px;
  font-weight: 600;
  border-bottom: 0.5px solid;
  border-color: ${({ theme }) => theme.colors.text};
  z-index: 9;
  h2 {
    margin: 0;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.text};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 60%;
    margin: 0px;
  }
  .go-back {
    cursor: pointer;
    filter: ${({ theme }) =>
      theme.colors.background === "#171717" ? "invert(1)" : "invert(0)"};
  }
  button {
    &:hover {
      box-shadow: 1px 4px 22px 0px rgba(95, 126, 251, 0.08);
    }
  }
`;

export const MessageContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const MessageBubble = styled.div<{ incoming: boolean }>`
  background-color: ${(props) => (props.incoming ? "#e0e0e0" : "#333")};
  color: ${(props) => (props.incoming ? "#000" : "#fff")};
  align-self: ${(props) => (props.incoming ? "flex-start" : "flex-end")};
  max-width: 70%;
  padding: 10px 15px;
  border-radius: 20px;
  word-wrap: break-word;
  p {
    margin: 0;
  }
  span {
    display: block;
    font-size: 0.75rem;
    margin-top: 5px;
    color: #888;
  }
`;

export const InputArea = styled.div`
  display: flex;
  padding: 10px;
  background-color: #ffffff;
  input {
    flex: 1;
    padding: 10px;
    border-radius: 20px;
    border: 1px solid #ddd;
    margin-right: 10px;
  }
  button {
    padding: 10px 20px;
    background-color: #333;
    color: #fff;
    border: none;
    border-radius: 20px;
    cursor: pointer;
  }
`;

export const StyledTab = styled.div<{ confirmed: boolean }>`
  font-size: 12px;
  color: ${({ theme, confirmed }) =>
    confirmed ? theme.colors.primary : theme.colors.secondary};
  margin-left: 20px;
`;

export const SkeletonMessage = styled.div`
  width: 100%;
  height: 52px;
  margin: 20px 0;
  background: ${({ theme }) => theme.colors.skeletonBackground};
  border-radius: 18px 18px 4px 18px;
  position: relative; /* Required for the ::after pseudo-element */
  overflow: hidden;
  animation: pulse 2s infinite; /* Apply pulsing animation to the entire skeleton */

  &::after {
    content: "";
    position: absolute;
    top: 0;
    border-radius: 18px 18px 4px 18px;
    left: -100%; /* Start shimmer effect off-screen */
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 50%,
      rgba(255, 255, 255, 0.2) 80%,
      rgba(255, 255, 255, 0) 100%
    );

    ${({ theme }) =>
      theme.colors.background === "#171717" &&
      `
      background: linear-gradient(
        90deg,
        rgba(20, 20, 20, 0) 0%,
        rgba(20, 20, 20, 0.2) 20%,
        rgba(20, 20, 20, 0.5) 50%,
        rgba(20, 20, 20, 0.2) 80%,
        rgba(20, 20, 20, 0) 100%
      );
    `}

    animation: shimmer 1.5s infinite; /* Shimmer effect */
  }

  @keyframes shimmer {
    0% {
      left: -100%; /* Start shimmer off-screen */
    }
    100% {
      left: 100%; /* End shimmer off-screen */
    }
  }

  @keyframes pulse {
    0% {
      opacity: 1; /* Start fully visible */
    }
    50% {
      opacity: 0.6; /* Midway less visible */
    }
    100% {
      opacity: 1; /* End back to fully visible */
    }
  }
`;
